import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "conditions__title" }

import { computed } from 'vue'

// Use
import useThemeClassName from '@/hooks/useThemeClassName'

// Types
import { Props } from './index'

// Components
import IconedText from '@/components/ui/IconedText'

// Props
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'Conditions',
  props: {
    theme: {},
    conditions: {}
  },
  setup(__props: any) {

const props = __props

// i18n
const { t } = useI18n()

// Computed
const conditionText = computed<string>(() => {
  if (props.conditions === 'full') {
    return t('conditions.full')
  } else {
    return `${t('conditions.refund')} ${props.conditions} %`
  }
})
const themeClassName = computed(() => useThemeClassName('conditions', props.theme))
const iconedTextTheme = computed(()=> (props.theme === 'big') ? 'font-default' : 'big')

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["conditions", [themeClassName.value]])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('conditions.title')) + ":", 1),
    _createVNode(_unref(IconedText), { theme: iconedTextTheme.value }, {
      icon: _withCtx(() => [
        _createVNode(_component_draw_svg, {
          name: "wallet",
          width: "38",
          height: "38"
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(" " + _toDisplayString(conditionText.value), 1)
      ]),
      _: 1
    }, 8, ["theme"])
  ], 2))
}
}

})